<template>
<div id="pageDashboard" class="customtable2">
    <v-container grid-list-xl fluid paddingZero>
        <v-dialog v-model="deleteModal" persistent max-width="290">
            <v-card>
                <v-toolbar color="orange" dark small>
                    <v-toolbar-title>Delete </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon @click="deleteModal=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    Are you sure you want to delete this ?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark" small @click="deleteModal=false">
                        No
                    </v-btn>
                    <v-btn color="orange " class="white-text" small @click="deleteMpCodes">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-toolbar class="dashboard-toolbar-admin" color="orange" dark>
            <v-toolbar-title>MP CODES</v-toolbar-title>
            <download-excel class="DivFlexInline" v-if="mpCodesList && mpCodesList.length > 0"
                :fetch= "generateData"
                :export-fields= "downloadExcelHeaders"
                :name= "`MPCODES.xls`"
            >
                <v-icon class="iconTitle">fa-file-excel</v-icon>  
            </download-excel>
            <div class="DivFlexInline">
                <v-icon class="iconTitle" v-if="mpCodesList && mpCodesList.length > 0" @click="downLoadPdf">fa-file-pdf </v-icon>
            </div>
            <v-spacer></v-spacer>
            <v-flex xs8 text-xs-right>
                <v-btn  @click="getmpCodesList()" class="refreshBtn" >
                    <i class="fas fa-sync-alt"></i>
                    REFRESH RESULTS 
                </v-btn>
            </v-flex>
        </v-toolbar>
        <v-layout  wrap>
            <v-flex lg12>
                <div class="padding_search">
                    <v-text-field solo append-outer-icon="search" class="customTxt" placeholder="Search" v-model="search"></v-text-field>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="custom-mb">
            <v-card>
                <v-card-text class="pa-0">
                    <v-spacer></v-spacer>
                    <v-toolbar color="grey darken-1" dark>
                        <v-flex xs12 md3></v-flex>
                        <v-flex xs12 md6 class="text-xs-center">
                            <v-pagination v-if="mpCodesList && mpCodesList.length > 0" v-model="pagination.page" :length="pages"></v-pagination>
                        </v-flex>
                        <v-flex xs12 md3 class="text-xs-right">
                            <v-layout align-center justify-end row fill-height class="text-xs-right">
                                <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                                <v-flex xs4 class="text-xs-right">
                                    <v-select class="custom_dropdown" v-model="pagination.rowsPerPage" :items="per_page_arr" data-vv-as="User Status" item-text="name" item-value="value" ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-toolbar>
                    <v-spacer></v-spacer>
                    <v-data-table 
                        :disable-initial-sort="true" 
                        :headers="headers" 
                        :search="search"
                        :items="mpCodesList" 
                        :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" 
                        :pagination.sync="pagination"
                        class="elevation-1 tableSquare"
                        hide-actions
                    >
                        <v-data-iterator
                            :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                            :pagination.sync="pagination"
                        />
                        <template slot="headers" slot-scope="props">
                            <tr>
                                <th v-for="header in props.headers" 
                                :key="header.text" 
                                :style="header.value == 'status' ? 'width:15%' : ''"
                                :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                                @click="changeSort(header.value)"
                                >
                                    <v-icon small>arrow_drop_up</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.code_name }} </td>
                            <td>{{ props.item.Source.name }}</td>
                            <td>{{ props.item.code }}</td>
                            <td>{{ props.item.description }}</td>
                            <td>{{ props.item.clicked }}</td>
                            <td>{{ props.item.completed }}</td>
                            <td>{{ props.item.creationDate }}</td>
                            <td>{{ props.item.startDate }}</td>
                            <td>{{ props.item.endDate }}</td>
                            <td>
                                <v-switch
                                    label=""
                                    @change="changeDisable(props.item,props.index)"
                                    v-model="props.item.disable"
                                ></v-switch>
                            </td>
                            <td>
                                <v-tooltip top>
                                    <v-btn slot="activator" class="remove-border" @click="onEdit(props.item)" depressed outline icon fab dark color="orange" small>
                                        <v-icon>fa-edit</v-icon>
                                    </v-btn>
                                    <span>Edit</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <v-btn slot="activator" @click="copyToClipboard(props.item)" class="remove-border" depressed outline icon fab dark color="orange" small>
                                        <v-icon class="main_ic" color="orange">assignment</v-icon>
                                    </v-btn>
                                    <span>Copy link to share</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <v-btn slot="activator" @click="showDeleteModal(props.item.uuid)" class="remove-border" depressed outline icon fab dark color="orange" small>
                                        <v-icon class="main_ic" color="orange">fa-trash</v-icon>
                                    </v-btn>
                                    <span>Delete</span>
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>

                    <v-divider></v-divider>
                </v-card-text>
            </v-card>
        </v-layout>
        <v-toolbar id="CreateCode" card color="white">
            <v-toolbar-title>
                <h3>Create Code</h3>
                <p class="subtitle">Create your custom codes below.</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout row wrap>
                <p></p>
            </v-layout>
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card>
                        <v-card-text class="pa-0 mt-2">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field label="Code Name *" :maxlength="32" v-model="form.code_name" v-validate="{required: 'form.code_name', max: 32,'restrictedWord':[]}" data-vv-name="code_name" placeholder="" :error-messages="errors.collect('code_name')" required data-vv-as="Code Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>
                                        <v-select class="custom_dropdown" v-validate="'required'" :items="source_arr" :error-messages="errors.collect('source_uuid')" data-vv-name="source_uuid" v-model="form.source_uuid" required data-vv-as="Source" item-text="name" item-value="uuid" label="Source *">
                                        </v-select>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field class="custom-picker-text" id="creation_date" v-validate="'required'" data-vv-name="creation_date" data-vv-as="Creation Date" :error-messages="errors.collect('creation_date')" slot="activator" label="Creation Date *" :value="displayDate(form.creation_date)" prepend-icon="event" disabled>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Description *" :maxlength="32" v-model="form.description" v-validate="{required: 'form.description', max: 32,'restrictedWord':[]}" data-vv-name="description" placeholder="" :error-messages="errors.collect('description')" required data-vv-as="Description">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg6 md6 xs12>
                                        <v-menu ref="picker_start_date" lazy :close-on-content-click="false" v-model="form.picker_start_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.start_date">
                                            <v-text-field class="custom-picker-text" id="start_date" data-vv-name="start_date" data-vv-as="Start Date" :error-messages="errors.collect('start_date')" slot="activator" label="Start Date" :value="displayDate(form.start_date)" prepend-icon="event" readonly>
                                            </v-text-field>
                                            <v-date-picker :min="minDate" v-model="form.start_date" no-title scrollable @input="changeDate('start_date'); $refs.picker_start_date.save(form.start_date)" :value="displayDate(form.start_date)">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex lg6 md6 xs12>
                                        <v-menu ref="picker_end_date" lazy :close-on-content-click="false" v-model="form.picker_end_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.end_date">
                                            <v-text-field class="custom-picker-text" id="end_date" v-validate="{start_date_req:[form.start_date],end_date_valid:[form.start_date]}" data-vv-name="end_date" data-vv-as="End Date" :error-messages="errors.collect('end_date')" slot="activator" label="End Date" :value="displayDate(form.end_date)" prepend-icon="event" readonly>
                                            </v-text-field>
                                            <v-date-picker :min="minDate" v-model="form.end_date" no-title scrollable @input="changeDate('end_date'); $refs.picker_end_date.save(form.end_date)" :value="displayDate(form.end_date)">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <div class="form-btn text-xs-right">
                                  <v-btn @click="resetForm" color="gray white--text"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                  <v-btn @click="submit" color="orange white--text" slot="activator"> Save </v-btn>
                                </div>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>
    </v-container>
    <GoogleAds></GoogleAds>
</div>
</template>
<script>
import API from "@/api";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import moment from "moment";
import axios from "axios";
import config from "../../config";
import services from "../../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {Validator} from 'vee-validate';
import {scroller} from 'vue-scrollto/src/scrollTo';
import jsPDF from 'jspdf';
Validator.extend('start_date_req', {
    getMessage: field => 'Please select the start date',
    validate: function (value, [start_date]) {
        if(!start_date){
            return false;
        }
        return true;
    }
});
Validator.extend('end_date_valid', {
    getMessage: field => 'End date should be greater than start date',
    validate: function (value, [start_date]) {
        if(moment(start_date).format('MMM DD, YYYY') > moment(value).format('MMM DD, YYYY')){
            return false;
        }
        return true;
    }
});
export default {
    components: {
        VWidget,
        GoogleAds
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
        pages () {
            if (this.pagination.rowsPerPage == null ||
            this.pagination.totalItems == null
            ) return 0

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        }
    },
    created (){
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                self.getmpCodesList()
                    .then(dataResults => {
                        return dataResults;
                })
                .catch(err => {
                    console.log(err)
                }),
                services.get("sources/list", {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (mpcodes, sources) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.mpCodesList = mpcodes.data.data.map(function(val){
                    val.startDate = (moment(val.start_date).format("YYYY") == '0001' ? null : moment(val.start_date).format("MMM DD, YYYY") );
                    val.endDate = (moment(val.end_date).format("YYYY") == '0001' ? null : moment(val.end_date).format("MMM DD, YYYY") );
                    val.creationDate = (moment(val.creation_date).format("YYYY") == '0001' ? null : moment(val.creation_date).format("MMM DD, YYYY") );
                    val.clicked = 0;
                    val.completed = 0;
                    if(val.code_analytics && val.code_analytics.length > 0){
                        val.code_analytics.map(function(ac){
                            val.clicked += ac.hit_count;
                            val.completed += ac.sign_up_count;
                        });
                    }
                    return val;
                });
                self.pagination.totalItems = self.mpCodesList.length;
                self.source_arr.push({
                    'name': 'Please Select Source',
                    'uuid': ''
                });
                if (sources.data.data.length > 0) {
                    sources.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.name;
                        newArr.uuid = data.uuid;
                        self.source_arr.push(newArr);
                    })
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
            });
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        changeSort (column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        changeDisable(data, index){
            const self = this,
                wApp = window.getApp;          
            const formData = {};
            formData.uuid = data.uuid;
            formData.status = data.disable ? 1:0;
            services.put("codes/update-status", formData,  {
                Authorization: "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                if(res.data.status){
                    self._showToast(res.data.message, 'green');
                    // self.mpCodesList[index].disable = (data.disable)?1:0;
                } else {
                    self.mpCodesList.map(function(val,i){
                        if(val.uuid == data.uuid){
                            self.mpCodesList[i].disable = (data.disable)?false:true;
                        }                    
                    });
                }
            })
            .catch(err => {
                self.mpCodesList.map(function(val,i){
                    if(val.uuid == data.uuid){
                        self.mpCodesList[i].disable = (data.disable)?false:true;
                    }                    
                });
                console.log(err)
            });
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        displayDate(selectedDate) {
            if(!selectedDate) {
                return '';
            }
            return moment(selectedDate).format(config.displayDateFormat);
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        },
        changeDate(id) {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById(id).dispatchEvent(evt);
            }, 10)
        },
        getmpCodesList(){
            const self = this;
            return new Promise(function(resolve, reject) {
                services.get("codes/list", {
                    Authorization: "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                });                
            });
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        let firstScrollTo = scroller();
                        const formData = Object.assign({}, self.form);
                        let apiUrl = "codes/new";
                        let apiService = "post";
                        if(self.form.uuid){
                            apiUrl = "codes/edit";
                            apiService = "put";
                            delete formData.Source;
                        } else {
                            formData.code = self.makeid(8);
                        }
                        formData.start_date = (moment(formData.start_date).format("YYYY") == '0001') ? null : moment(formData.start_date).format("YYYY-MM-DD");
                        formData.end_date = (moment(formData.end_date).format("YYYY") == '0001') ? null : moment(formData.end_date).format("YYYY-MM-DD");
                        formData.creation_date = (moment(formData.creation_date).format("YYYY") == '0001') ? null : moment(formData.creation_date).format("YYYY-MM-DD");
                        services[apiService](apiUrl, formData, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                })
                            .then(res => {
                                firstScrollTo('#pageDashboard');
                                if (res.data.status) {
                                    self._showToast(res.data.message, 'green');
                                    self.updateMpCodesList();
                                } else {
                                    wApp.$emit("showLoader", {
                                        show: false
                                    });
                                    self._showToast(res.data.message, 'red');
                                }
                            })
                            .catch(err => {
                                firstScrollTo('#pageDashboard');
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        onEdit(itemValue){
            const self = this;
            self.form = Object.assign({}, itemValue);
            self.form.start_date = (moment(self.form.start_date).format("YYYY") == '0001') ? null : moment(self.form.start_date).format("YYYY-MM-DD");
            self.form.end_date = (moment(self.form.end_date).format("YYYY") == '0001') ? null : moment(self.form.end_date).format("YYYY-MM-DD");
            self.form.creation_date = (moment(self.form.creation_date).format("YYYY") == '0001') ? null : moment(self.form.creation_date).format("YYYY-MM-DD");
            delete self.form.user_uuid;
            let firstScrollTo = scroller();
            firstScrollTo('#CreateCode');
        },
        resetForm(){
            const self = this;
            self.$validator.reset();
            self.form = Object.assign({},self.defaultFormData);
        },
        copyToClipboard (dataObj){
            const self = this;
            let referralUrl = config.imrReferralUrl+"utm_campaign=mp&utm_code="+dataObj.code;
            let textArea = document.createElement("textarea");
            textArea.value = referralUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            textArea.remove();
            self._showToast('Url copied');
        },
        showDeleteModal (id){
            const self = this;
            self.deleteMpCodesId = id;
            self.deleteModal = true;
        },
        deleteMpCodes(){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services.delete("codes/delete", {uuid:self.deleteMpCodesId}, {
                "Authorization": "Bearer " + self.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.data) {
                    self._showToast(res.data.message);
                } else {
                    self._showToast(config.tryAgainLetterMSG,config.errMsgColorStr);
                }
                self.deleteModal = false;  
                self.deleteMpCodesId = null;
                self.updateMpCodesList();
            })
            .catch(err => {
                self.deleteModal = false;
                self.deleteMpCodesId = null;
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message,config.errMsgColorStr);
                self.updateMpCodesList();
            });
        },
        updateMpCodesList(){
            const self = this,wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.getmpCodesList().then(dataResults => {
                self.$validator.reset()
                self.form = Object.assign({},self.defaultFormData);
                self.mpCodesList = dataResults.data.data.map(function(val,i){
                    val.startDate = (moment(val.start_date).format("YYYY") == '0001' ? null : moment(val.start_date).format("MMM DD, YYYY") );
                    val.endDate = (moment(val.end_date).format("YYYY") == '0001' ? null : moment(val.end_date).format("MMM DD, YYYY") );
                    val.creationDate = (moment(val.creation_date).format("YYYY") == '0001' ? null : moment(val.creation_date).format("MMM DD, YYYY") );
                    val.clicked = 0;
                    val.completed = 0;
                    if(val.code_analytics && val.code_analytics.length > 0){
                        val.code_analytics.map(function(ac){
                            val.clicked += ac.hit_count;
                            val.completed += ac.sign_up_count;
                        });
                    }
                    return val;
                });
                self.pagination.totalItems = self.mpCodesList.length;
                let firstScrollTo = scroller();
                firstScrollTo('#pageDashboard');
                wApp.$emit("showLoader", {
                    show: false
                });
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
            });
        },
        downLoadPdf(){
            const self = this;
            let headers = self.createHeaders();
            let doc = new jsPDF(
                {
                    orientation: 'landscape',
                    format: [2300,2300]
                }
            );
            let pdf = doc.table(1, 1, self.generateData(), headers, { autoSize: true,headerBackgroundColor:'#ff812b'});
            pdf.save('MPCODES.pdf');
        },
        createHeaders() {
            let keys = Object.keys(this.downloadExcelHeaders);
            let result = [];
            for (let i = 0; i < keys.length; i += 1) {
                result.push({
                    'id' : keys[i],
                    'name': keys[i],
                    'prompt': keys[i]
                });
            }
            return result;
        },
        generateData() {
            const self = this;
            let result = [];
            for (let i = 0; i < self.mpCodesList.length; i += 1) {
                let tmp = self.mpCodesList[i];
                let data = {
                    "CODE NAME":(tmp.code_name)?tmp.code_name.toString():'',
                    "SOURCE":(tmp.Source.name)?tmp.Source.name.toString():'',
                    "CODE":(tmp.code)?tmp.code.toString():'',
                    "DESCRIPTION":(tmp.description)?tmp.description.toString():'',
                    "CLICKED":(tmp.clicked)?tmp.clicked.toString():'0',
                    "COMPLETED":(tmp.completed)?tmp.completed.toString():'0',
                    "CREATION DATE":(tmp.creationDate)?tmp.creationDate.toString():'',
                    "START DATE":(tmp.startDate)?tmp.startDate.toString():'',
                    "END DATE":(tmp.endDate)?tmp.endDate.toString():'',
                    "DISABLED":(tmp.disable)?'1':'0'
                }
                result.push(Object.assign({}, data));
            }
            return result;
        },
    },
    data() {
        return {
            pagination: {rowsPerPage :10,totalItems :null},
            per_page_arr: [
                {
                    name:'10',
                    value:10
                },
                {
                    name:'20',
                    value:20
                },
                {
                    name:'All',
                    value:1000
                },
            ],
            picker_start_date: false,
            picker_end_date: false,
            source_arr: [],
            mpCodesList: [],
            defaultFormData: {
                code_name: '',
                code: '',
                description: '',
                source_uuid: '',
                start_date: null,
                end_date: null,
                creation_date: new Date().toISOString().substr(0, 10),
            },
            form: {
                code_name: '',
                code: '',
                description: '',
                source_uuid: '',
                user_uuid: '',
                start_date: null,
                end_date: null,
                creation_date: new Date().toISOString().substr(0, 10),
            },
            headers: [{
                    text: 'CODE NAME',
                    align: 'left',
                    value: 'code_name'
                },
                {
                    text: 'SOURCE',
                    align: 'left',
                    value: 'Source.name'
                },
                {
                    text: 'CODE',
                    align: 'left',
                    value: 'code'
                },
                {
                    text: 'DESCRIPTION',
                    align: 'left',
                    value: 'description'
                },
                {
                    text: 'CLICKED',
                    align: 'left',
                    value: 'clicked'
                },
                {
                    text: 'COMPLETED',
                    align: 'left',
                    value: 'completed'
                },
                {
                    text: 'CREATION DATE',
                    align: 'left',
                    value: 'creation_date'
                },
                {
                    text: 'START DATE',
                    align: 'left',
                    value: 'start_date'
                },
                {
                    text: 'END DATE',
                    align: 'left',
                    value: 'end_date'
                },
                {
                    text: 'DISABLED',
                    value: "",
                    sortable: false,
                    align: 'left'
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false,
                    align: 'left',
                    width: "20%"
                }
            ],
            deleteModal: false,
            deleteMpCodesId: null,
            search: "",
            downloadExcelHeaders:{
                "CODE NAME":"CODE NAME",
                "SOURCE":"SOURCE",
                "CODE":"CODE",
                "DESCRIPTION":"DESCRIPTION",
                "CLICKED":"CLICKED",
                "COMPLETED":"COMPLETED",
                "CREATION DATE":"CREATION DATE",
                "START DATE":"START DATE",
                "END DATE":"END DATE",
                "DISABLED":"DISABLED"
            }
        }
    },
};
</script>

<style lang="stylus">
.custom_table th,.custom_table td
    padding: 5px;
.v-input--selection-controls__ripple, .v-input--selection-controls__input
    height:auto;
    width:auto;
.v-input--selection-controls
    margin-top: 0px; 
.v-btn.remove-border
    border: none !important;
.tableSquare tbody td
    font-weight: 400;
    font-size: 13px;
    border-right: #ccc solid 1px;
    vertical-align: middle;
.tableSquare .v-datatable thead th.column.sortable:hover, .tableSquare .v-datatable thead th.column.sortable.active
    color: #fff !important;
</style>



// WEBPACK FOOTER //
// src/pages/mpcodes/List.vue